import React from 'react'
import style from './auth.module.scss'
import { LogoSignin } from 'media/icons'
import Divider from 'components/Divider'
import { Form } from 'informed'

const AuthContainer = ({ children, render, ...formProps }) => (
	<Form {...formProps} className={style.root} render={(...args) => (
		<div className={style.container}>
			<LogoSignin/>
			<Divider visible height={76} style={{ background: '#2f3648', width: '250px' }}/>
			{typeof render === 'function' ? render(...args) : children(...args)}
		</div>
	)}/>
)

export default AuthContainer
